/**
 * Description Input Component
 * 
 * Reusable description textarea.
 * Memoized to prevent re-renders when other form fields change.
 */

import { memo } from 'react';

interface DescriptionInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    rows?: number;
}

function DescriptionInputComponent({
    value,
    onChange,
    placeholder = "Add a note...",
    rows = 3
}: DescriptionInputProps) {
    return (
        <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
                Description (optional)
            </label>
            <textarea
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:border-teal-500 focus:ring-1 focus:ring-teal-500 outline-none resize-none"
                rows={rows}
            />
        </div>
    );
}

/**
 * Memoized version prevents re-renders when other form fields change.
 */
export const DescriptionInput = memo(DescriptionInputComponent);
